import React from 'react';
import { Button } from '../components/ui/Button';
import { CONTACT_EMAIL, mailto } from '../lib/site';

/** Prefilled subject so the sender names the service on the subject line. */
const SUPPORT_SUBJECT = 'Service: ';

/**
 * Support intake. Tickets are closed; the only path is email.
 */
const SubmitTicket: React.FC = () => (
  <div className="bg-secondary-950">
    <section className="page-shell page-section-major">
      <div className="page-inner">
        <header className="mb-6">
          <p className="text-xs font-medium tracking-[0.24em] uppercase mb-3 text-secondary-500">Support</p>
          <h1 className="text-3xl sm:text-5xl font-bold tracking-tight mb-2">
            <span className="cw">Support </span>
            <span className="cb">tickets</span>
          </h1>
        </header>
        <div className="rounded-2xl border border-secondary-700/60 bg-secondary-900 p-6 sm:p-8">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-3">Support tickets are currently unavailable</h2>
          <p className="text-secondary-300 leading-relaxed mb-4">
            Email us instead. Put the service you are having trouble with in the subject line.
          </p>
          <p className="mb-6">
            <a
              href={mailto(SUPPORT_SUBJECT)}
              className="text-lg font-semibold text-primary-300 hover:text-primary-200 break-all underline underline-offset-4 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
            >
              {CONTACT_EMAIL}
            </a>
          </p>
          <Button href={mailto(SUPPORT_SUBJECT)}>Email support</Button>
        </div>
      </div>
    </section>
  </div>
);

export default SubmitTicket;
